/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
import isType from './is-type';

const isBoolean = function(value: any): value is boolean {
  return isType(value, 'Boolean');
};

export default isBoolean;
